import styled from "styled-components";
import { Container } from "react-grid-system";
// import { theme } from "../theme";

export const StyledAddUpperUnitIcon = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
`;

export const StyledAddUpperUnitOptions = styled(Container)`
	& > div {
		margin-bottom: 1rem;

		&:last-child {
			margin: 0;
		}
	}
`;

export const StyledAddUpperUnitActions = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	column-gap: 4.5rem;
`;
